<template>
  <div class="m-page">
    <div class="m-container">

      <!-- HEADER -->
      <div class="m-header">
        <div class="d-flex align-items-center">
          <button class="m-back" @click="$router.push('/xisobot/main')" type="button">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <h2 class="m-title">Usta sverka</h2>
        </div>
        <div class="m-actions">
          <button class="m-btn m-btn-secondary" @click="exportExcel" :disabled="loading || !items.length">
            <b-icon icon="file-earmark-excel" class="mr-1"></b-icon> Excel
          </button>
          <button class="m-btn m-btn-secondary" @click="doPrint" :disabled="loading || !items.length">
            <b-icon icon="printer" class="mr-1"></b-icon> Pechat
          </button>
        </div>
      </div>

      <!-- FILTRLAR -->
      <div class="m-filters">
        <div class="m-filter">
          <label>Boshlanish</label>
          <input type="date" v-model="date1" @change="fetch">
        </div>
        <div class="m-filter">
          <label>Tugash</label>
          <input type="date" v-model="date2" @change="fetch">
        </div>
        <div class="m-filter m-filter-grow">
          <label>Sklad</label>
          <v-select class="m-vselect" :options="skladList" v-model="sklad_id"
            :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="m-filter">
          <label>&nbsp;</label>
          <button class="m-btn m-btn-primary" @click="fetch" :disabled="loading">
            <b-icon icon="arrow-repeat" class="mr-1"></b-icon> Yangilash
          </button>
        </div>
      </div>

      <!-- SUMMARY -->
      <div class="m-summary">
        <div class="sum-card sum-1">
          <div class="sum-label">XIZMAT NARXI</div>
          <div class="sum-value">{{ formatMoney(totals.service_revenue) }}</div>
        </div>
        <div class="sum-card sum-2">
          <div class="sum-label">MAHSULOT (SOTUV)</div>
          <div class="sum-value">{{ formatMoney(totals.product_revenue) }}</div>
        </div>
        <div class="sum-card sum-3">
          <div class="sum-label">MAHSULOT TANNARX</div>
          <div class="sum-value">{{ formatMoney(totals.product_cost) }}</div>
        </div>
        <div class="sum-card sum-4">
          <div class="sum-label">MAHSULOT FOYDASI</div>
          <div class="sum-value">{{ formatMoney(totals.product_profit) }}</div>
        </div>
        <div class="sum-card sum-5">
          <div class="sum-label">USTA ULUSHI</div>
          <div class="sum-value">{{ formatMoney(totals.master_share) }}</div>
        </div>
        <div class="sum-card sum-6">
          <div class="sum-label">ISHXONA SOF FOYDA</div>
          <div class="sum-value">{{ formatMoney(totals.net_profit) }}</div>
        </div>
      </div>

      <!-- TABLE -->
      <div class="m-card" ref="printRoot">
        <div class="m-table-wrapper">
          <table class="m-table">
            <thead>
              <tr>
                <th style="width: 44px">#</th>
                <th>Usta</th>
                <th>Turi</th>
                <th class="t-center">Mijoz</th>
                <th class="t-center">Sotuv</th>
                <th class="t-right">Xizmat narxi</th>
                <th class="t-right">Mahsulot (sotuv)</th>
                <th class="t-right">Tannarx</th>
                <th class="t-right">Mahsulot foydasi</th>
                <th class="t-right">Usta ulushi</th>
                <th class="t-right">Sof foyda</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="11" class="m-empty"><b-spinner small></b-spinner> Yuklanmoqda...</td>
              </tr>
              <tr v-for="(it, idx) in items" :key="it.staff_id">
                <td><span class="m-num">{{ idx + 1 }}</span></td>
                <td class="m-name">{{ it.staff_name || '—' }}</td>
                <td>
                  <span class="m-badge" :class="it.type === 'kunlik' ? 'm-badge-amber' : 'm-badge-purple'">
                    {{ it.type === 'kunlik' ? 'Kunlik' : (it.type === 'foizli' ? it.bonus_percent + '%' : '—') }}
                  </span>
                </td>
                <td class="t-center"><span class="m-badge m-badge-info">{{ it.clients_count }}</span></td>
                <td class="t-center"><span class="m-badge m-badge-blue">{{ it.sales_count }}</span></td>
                <td class="t-right m-strong">{{ formatMoney(it.service_revenue) }}</td>
                <td class="t-right">{{ formatMoney(it.product_revenue) }}</td>
                <td class="t-right m-muted">{{ formatMoney(it.product_cost) }}</td>
                <td class="t-right" :class="it.product_profit >= 0 ? 'm-green' : 'm-red'">{{ formatMoney(it.product_profit) }}</td>
                <td class="t-right m-orange">{{ formatMoney(it.master_share) }}</td>
                <td class="t-right" :class="balanceClass(it.net_profit)">{{ formatMoney(it.net_profit) }}</td>
              </tr>
              <tr v-if="!loading && items.length === 0">
                <td colspan="11" class="m-empty">Ma'lumot topilmadi</td>
              </tr>
            </tbody>
            <tfoot v-if="items.length > 0">
              <tr>
                <th colspan="3" class="t-right">JAMI:</th>
                <th class="t-center">{{ totals.clients_count }}</th>
                <th class="t-center">{{ totals.sales_count }}</th>
                <th class="t-right">{{ formatMoney(totals.service_revenue) }}</th>
                <th class="t-right">{{ formatMoney(totals.product_revenue) }}</th>
                <th class="t-right">{{ formatMoney(totals.product_cost) }}</th>
                <th class="t-right">{{ formatMoney(totals.product_profit) }}</th>
                <th class="t-right">{{ formatMoney(totals.master_share) }}</th>
                <th class="t-right">{{ formatMoney(totals.net_profit) }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'MasterSverka',
  data() {
    const today = new Date();
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.dateStr(first),
      date2: this.dateStr(today),
      sklad_id: null,
      skladList: [],
      items: [],
      periodDays: 0,
      loading: false,
    };
  },
  computed: {
    totals() {
      const t = {
        clients_count: 0, sales_count: 0, service_revenue: 0, product_revenue: 0,
        product_cost: 0, product_profit: 0, master_share: 0, net_profit: 0,
      };
      for (const it of this.items) {
        t.clients_count += Number(it.clients_count) || 0;
        t.sales_count += Number(it.sales_count) || 0;
        t.service_revenue += parseFloat(it.service_revenue) || 0;
        t.product_revenue += parseFloat(it.product_revenue) || 0;
        t.product_cost += parseFloat(it.product_cost) || 0;
        t.product_profit += parseFloat(it.product_profit) || 0;
        t.master_share += parseFloat(it.master_share) || 0;
        t.net_profit += parseFloat(it.net_profit) || 0;
      }
      return t;
    },
  },
  mounted() {
    this.loadSklads();
    this.fetch();
  },
  methods: {
    dateStr(d) {
      if (!d) return '';
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    toUnix(dateStr, endOfDay = false) {
      if (!dateStr) return 0;
      const d = new Date(dateStr + (endOfDay ? 'T23:59:59' : 'T00:00:00'));
      return Math.floor(d.getTime() / 1000);
    },
    async loadSklads() {
      try {
        const res = await axios.get('api/v1/sklads');
        this.skladList = res.data || [];
      } catch (e) { this.skladList = []; }
    },
    async fetch() {
      this.loading = true;
      try {
        const res = await axios.post('api/v1/report/master-sverka/', {
          datetime1: this.toUnix(this.date1, false),
          datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        const data = res.data || {};
        this.items = Array.isArray(data.items) ? data.items : [];
        this.periodDays = data.period ? data.period.days : 0;
      } catch (e) {
        console.error('Usta sverka error:', e);
        this.items = [];
        this.$store && (this.$store.state.errors = "Hisobotni yuklashda xatolik");
      } finally {
        this.loading = false;
      }
    },
    formatMoney(v) {
      const num = parseFloat(v) || 0;
      return num.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    balanceClass(v) {
      const num = parseFloat(v) || 0;
      if (num > 0) return 'm-green m-strong';
      if (num < 0) return 'm-red m-strong';
      return 'm-muted';
    },
    doPrint() {
      window.print();
    },
    exportExcel() {
      const headers = ['Usta', 'Turi', 'Mijoz', 'Sotuv', 'Xizmat narxi', 'Mahsulot sotuv', 'Tannarx', 'Mahsulot foydasi', 'Usta ulushi', 'Sof foyda'];
      const rows = this.items.map(it => [
        it.staff_name || '', it.type, it.clients_count, it.sales_count,
        it.service_revenue, it.product_revenue, it.product_cost, it.product_profit,
        it.master_share, it.net_profit,
      ]);
      const csv = [headers, ...rows].map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿" + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `usta_sverka_${this.date1}_${this.date2}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.m-page { padding: 20px; background: #f4f7f9; height: calc(100vh - 56px); overflow-y: auto; }
.m-container { max-width: 1500px; margin: 0 auto; }
.m-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.m-back { width: 40px; height: 40px; border-radius: 50%; border: 1px solid #e0e6ed; background: white; color: #7f8c8d; display: flex; align-items: center; justify-content: center; cursor: pointer; margin-right: 12px; }
.m-title { font-weight: 800; font-size: 24px; color: #2c3e50; margin: 0; }
.m-actions { display: flex; gap: 10px; }
.m-btn { border: none; padding: 10px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; }
.m-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.m-btn-primary { background: #a142f4; color: white; }
.m-btn-primary:hover:not(:disabled) { background: #8e39d9; }
.m-btn-secondary { background: white; color: #475569; border: 1px solid #cbd5e1; }
.m-btn-secondary:hover:not(:disabled) { background: #f1f5f9; border-color: #a142f4; color: #a142f4; }

.m-filters { display: flex; gap: 12px; background: white; padding: 14px; border-radius: 14px; margin-bottom: 20px; box-shadow: 0 4px 14px rgba(0,0,0,0.02); border: 1px solid #f1f5f9; align-items: flex-end; }
.m-filter { display: flex; flex-direction: column; min-width: 150px; }
.m-filter-grow { flex: 1; min-width: 200px; }
.m-filter label { font-size: 11px; color: #94a3b8; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
.m-filter input { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 9px 12px; font-weight: 600; color: #2c3e50; outline: none; }
.m-filter input:focus { border-color: #a142f4; background: white; }
.m-vselect ::v-deep .vs__dropdown-toggle { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 3px; }

.m-summary { display: grid; grid-template-columns: repeat(6, 1fr); gap: 12px; margin-bottom: 20px; }
.sum-card { background: white; border-radius: 14px; padding: 14px 16px; border: 1px solid #f1f5f9; box-shadow: 0 4px 14px rgba(0,0,0,0.02); }
.sum-1 { border-top: 3px solid #a142f4; }
.sum-2 { border-top: 3px solid #2563eb; }
.sum-3 { border-top: 3px solid #ef4444; }
.sum-4 { border-top: 3px solid #10b981; }
.sum-5 { border-top: 3px solid #f59e0b; }
.sum-6 { border-top: 3px solid #6366f1; }
.sum-label { font-size: 10px; font-weight: 800; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 6px; }
.sum-value { font-size: 18px; font-weight: 800; color: #0f172a; }

.m-card { background: white; border-radius: 18px; padding: 6px; box-shadow: 0 10px 30px rgba(0,0,0,0.03); border: 1px solid #f1f5f9; }
.m-table-wrapper { overflow-x: auto; border-radius: 12px; }
.m-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 13px; }
.m-table th { background: #f8fafc; padding: 12px 10px; color: #64748b; font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.4px; border-bottom: 2px solid #e2e8f0; position: sticky; top: 0; }
.m-table td { padding: 12px 10px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; color: #334155; }
.m-table tfoot th { background: #fef3c7; font-size: 12px; color: #92400e; border-top: 2px solid #fbbf24; border-bottom: none; position: static; }
.m-table tbody tr:hover { background: #faf8ff; }

.t-center { text-align: center; }
.t-right { text-align: right; font-variant-numeric: tabular-nums; }
.m-num { background: #f1f5f9; padding: 3px 8px; border-radius: 6px; font-size: 11px; font-weight: 700; color: #64748b; }
.m-name { font-weight: 700; color: #0f172a; }
.m-muted { color: #94a3b8; }
.m-strong { font-weight: 700; color: #0f172a; }
.m-green { color: #16a34a; }
.m-red { color: #e11d48; }
.m-orange { color: #d97706; font-weight: 700; }

.m-badge { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; }
.m-badge-info { background: #cffafe; color: #0891b2; }
.m-badge-blue { background: #dbeafe; color: #2563eb; }
.m-badge-purple { background: #f3e8ff; color: #a142f4; }
.m-badge-amber { background: #fef3c7; color: #b45309; }

.m-empty { text-align: center; padding: 40px; color: #94a3b8; font-style: italic; }

@media print {
  .m-page { background: white; padding: 0; height: auto; overflow: visible; }
  .m-actions, .m-filters, .m-back { display: none !important; }
  .m-card { box-shadow: none; border: none; }
}
</style>
